import { useSelector } from 'react-redux';
import { pendingRequestsSelector } from '../actions/ui/selectors';
import { getCall } from '../utils/apiLoading';

/**
 * Hook for checking if an action is in progress
 *
 * @param {string} action
 * @returns {{
 *  isRequestPending: boolean
 * }}
 */
function useApiLoading(action: string) {
  const pendingRequests = useSelector(pendingRequestsSelector);
  const call = getCall(action);
  const isRequestPending = pendingRequests.includes(call);

  return {
    isRequestPending,
  };
}

export default useApiLoading;
